import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { ErrorPage } from 'cpfr-common';
import { fetchUnauthorizedErrorPage } from './UnauthorizedErrorPageSlice';
import { UnauthorizedErrorPageContentSelector } from './UnauthorizedErrorPageContentSelector';

export function useUnauthorizedErrorPage(): AbstractContentState<ErrorPage> {
    return useCmsContent(fetchUnauthorizedErrorPage, UnauthorizedErrorPageContentSelector);
}
